<template>
    <div class="context">
        <div class="header">
            <div class="btn_box">
                <div class="btn nomal_btn" @click="goBack">
                    <i class="el-icon-back"></i>
                    返回
                </div>
            </div>
            <div class="title">{{viewTitle}}</div>
        </div>

        <div class="main_box">
            <el-form :model="form" ref="ruleForm" label-width="100px" :rules="rules">
                <el-form-item label="阶段:">
                    <div class="stage_item" v-for="(item, index) in form.stage_list" :key="index">
                        <div class="stage_title">
                            <div class="title">T{{index + 1}}, 共{{item.days}}天</div>
                            <div class="btn_box">
                                <div class="btn del_icon"
                                     v-if="form.stage_list.length > 1"
                                     @click="delStage(index)">删除</div>
                                <div class="btn"
                                     v-if="index === form.stage_list.length - 1"
                                     @click="addStage()">添加</div>
                            </div>
                        </div>
                        <div class="cycle_item"
                             v-for="(items, indexs) in item.cycle_list"
                             :key="indexs">
                            <div class="cycle_box">
                                <div class="title"
                                     v-text="showCycle(index, indexs)">
                                </div>
                                <div class="input_box">
                                    <el-input class="width_200"
                                              placeholder="名称"
                                              v-model="items.name"></el-input>
                                    <span>：</span>
                                    <span>共 {{items.days}} 天</span>
                                </div>
                                <div class="btn_box">
                                    <div class="icon del_icon"
                                         @click="delCycle(index, indexs)"
                                         v-if="item.cycle_list.length > 1">
                                        <i class="el-icon-remove-outline"></i>
                                    </div>
                                    <div class="icon"
                                         v-if="indexs === item.cycle_list.length - 1"
                                         @click="addCycle(index)">
                                        <i class="el-icon-circle-plus-outline"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="week_box" v-if="items.week_month_list">
                                <div v-for="(item_w, index_w) in items.week_month_list"
                                     :key="index_w"
                                     class="week_item">
                                    <div class="week_title">
                                        <span v-if="index_w === 0">周/月:</span>
                                    </div>
                                    <div class="week_input_box">
                                        <el-input class="width_200"
                                                  placeholder="名称"
                                                  size="small"
                                                  v-model="item_w.name"></el-input>
                                        <span>：</span>
                                        <el-input-number v-model="item_w.days"
                                                         size="small"
                                                         controls-position="right"
                                                         @change="changeNum(index, indexs)"
                                                         :min="0"></el-input-number>
                                        <span> 天</span>
                                    </div>
                                    <div class="week_btn_box">
                                        <div class="icon del_icon"
                                             @click="delWeek(index, indexs, index_w)"
                                             v-if="items.week_month_list.length > 1">
                                            <i class="el-icon-remove-outline"></i>
                                        </div>
                                        <div class="icon"
                                             v-if="index_w === items.week_month_list.length - 1"
                                             @click="addWeek(index, indexs)">
                                            <i class="el-icon-circle-plus-outline"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="submit">提交</el-button>
                    <el-button @click="goBack">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {clone} from "@/global/utils";

    export default {
        name: "commonIll",
        data() {
            return {
                viewTitle: '默认周期',
                form: {
                    stage_list: [
                        {
                            name: 'T1',
                            days: 0,
                            cycle_list: [
                                {
                                    name: '',
                                    days: 0,
                                    week_month_list: [
                                        {name: '', days: 0}
                                    ]
                                }
                            ]
                        }
                    ],
                },
                rules: {
                    name: [{required: true, message: '请输入名称！', trigger: 'blur'}]
                },
                approvedOption: [
                    {name: '是', value: 1},
                    {name: '否', value: 2}
                ]
            }
        },
        computed: {
            ...mapState('manageData', [
                'ill_data'
            ])
        },
        mounted() {
            this.getCommonData()
        },
        methods: {
            goBack() {
                this.$emit('changeTopTab', 'tableView')
            },
            getCommonData() {
                this.httpGet('/tumour/default').then(res => {
                    if (res.data && res.data.stage_list && res.data.stage_list.length > 0) {
                        this.form = res.data
                    } else {
                        this.form = {
                            stage_list: [
                                {
                                    name: 'T1',
                                    days: 0,
                                    cycle_list: [
                                        {
                                            name: '',
                                            days: 0,
                                            week_month_list: [
                                                {name: '', days: 0}
                                            ]
                                        }
                                    ]
                                }
                            ],
                        }
                    }
                })
            },

            showCycle(index, indexs) {
                let list = this.form.stage_list;
                let num = 0;
                for (let i = 0; i<index; i++) {
                    num = num + list[i].cycle_list.length
                }
                num = num + indexs + 1;
                return `Cycle${num}:`
            },

            changeNum(index, indexs) {
                let num_t = 0, num_c = 0;
                this.form.stage_list[index].cycle_list.forEach((v, i) => {
                    v.week_month_list.forEach(e => {
                        if (e.days) {
                            num_t += e.days
                        }
                    });
                    if (i === indexs) {
                        v.week_month_list.forEach(e => {
                            if (e.days) {
                                num_c += e.days
                            }
                        });
                    }
                });
                this.form.stage_list[index].days = num_t;
                if (indexs) {
                    this.form.stage_list[index].cycle_list[indexs].days = num_c;
                }
            },


            addStage() {
                let item = {
                    name: '',
                    days: 0,
                    cycle_list: [
                        {
                            name: '',
                            days: 0,
                            week_month_list: [
                                {name: '', days: 0}
                            ]
                        }
                    ]
                };
                this.form.stage_list.push(item)
            },
            delStage(index) {
                this.form.stage_list.splice(index, 1)
            },
            addCycle(index) {
                let item = {
                    name: '',
                    days: 0,
                    week_month_list: [
                        {name: '', days: 0}
                    ]
                };
                this.form.stage_list[index].cycle_list.push(item)
            },
            delCycle(index, indexs) {
                this.form.stage_list[index].cycle_list.splice(indexs, 1);
                this.changeNum(index)
            },
            addWeek(index, indexs) {
                let item = {
                    name: '',
                    days: 0,
                };
                this.form.stage_list[index].cycle_list[indexs].week_month_list.push(item)
            },
            delWeek(index, indexs, index_w) {
                this.form.stage_list[index].cycle_list[indexs].week_month_list.splice(index_w, 1);
                this.changeNum(index, indexs)
            },
            submit() {
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        this.form.stage_list.forEach((v, i) => {
                            v.name = `T${i + 1}`
                        });
                        this.httpPost('/tumour/default', this.form).then(res => {
                            this.$message.success('添加成功！');
                            this.goBack()
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    $view_background: rgb(246, 247, 248);
    $btn_border: rgb(246, 247, 248);
    .context {
        width: 100%;
        height: 100%;
        background: $view_background;
        display: flex;
        flex-flow: column;
        .del_icon {
            color: #F56C6C;
        }

        .header {
            width: 100%;
            line-height: 50px;
            padding: 0 15px;
            box-sizing: border-box;
            display: flex;
            border-bottom: 1px solid #ddd;
            /*color: #8d8d8d;*/
            .title {

            }
            .btn_box {
                padding-right: 20px;
                .btn {
                    margin-top: 10px;
                    border: 1px solid $btn_border;
                }
            }
        }
        .main_box {
            flex: 1;
            padding: 10px;
            overflow: hidden;
            overflow-y: auto;
            .stage_item {
                width: 600px;
                border-radius: 3px;
                padding: 5px;
                background: #fff;
                .stage_title {
                    background: #f5f7fa;
                    line-height: 40px;
                    width: 100%;
                    padding: 0 20px;
                    display: flex;
                    justify-content: space-between;
                    box-sizing: border-box;
                    .btn_box {
                        display: flex;
                        .btn {
                            padding: 0 10px;
                        }
                    }
                }
                .cycle_item {
                    padding-left: 40px;
                    line-height: 40px;
                    padding-bottom: 5px;
                    margin: 5px 0;
                    .cycle_box {
                        display: flex;
                        .title {
                            flex: 0 0 50px;
                            width: 50px;
                            text-align: center;
                        }
                        .input_box {
                            flex: 1;
                            span {
                                padding: 0 5px;
                            }
                        }
                        .btn_box {
                            flex: 0 0 200px;
                            display: flex;
                            .icon {
                                /*flex: 1;*/
                                width: 40px;
                                line-height: 40px;
                                font-size: 1.5rem;
                                cursor: pointer;
                            }

                        }
                    }
                    &:last-child {
                        padding-bottom: 0;
                    }
                    .week_box {
                        padding-left: 40px;
                        line-height: 40px;
                        padding-bottom: 5px;
                        margin: 5px 0;
                        &:last-child {
                            padding-bottom: 0;
                        }
                        .week_item {
                            display: flex;
                            .week_title {
                                flex: 0 0 50px;
                                width: 50px;
                                text-align: center;
                            }
                            .week_input_box {
                                flex: 1;
                                span {
                                    padding: 0 5px;
                                }
                            }
                            .week_btn_box {
                                flex: 0 0 80px;
                                display: flex;
                                .icon {
                                    flex: 1;
                                    width: 40px;
                                    line-height: 40px;
                                    font-size: 1.5rem;
                                    cursor: pointer;
                                }

                            }
                        }
                    }
                }
            }

            .sql_box {
                width: 600px;
                background: #fff;
                border-radius: 3px;
                padding: 5px;
                .sql_item {
                    line-height: 40px;
                    display: flex;
                    padding-bottom: 5px;
                    &:last-child {
                        padding-bottom: 0;
                    }
                    .title {
                        flex: 0 0 50px;
                        width: 50px;
                        text-align: center;
                    }
                    .input_box {
                        flex: 1;
                        span {
                            padding: 0 5px;
                        }
                    }
                    .btn_box {
                        flex: 0 0 80px;
                        display: flex;
                        .icon {
                            flex: 1;
                            width: 40px;
                            line-height: 40px;
                            font-size: 1.5rem;
                            cursor: pointer;
                        }
                        .del_icon {
                            color: #F56C6C;
                        }
                    }
                }
            }
        }
    }
</style>